<template>
  <div :class="`BgBanner ${isOpen ? 'BgBanner--open' : 'BgBanner--closed'}`">
    <div v-if="isOpen">
      <h3 class="BgBanner__title">{{ title }}</h3>
      <div class="BgBanner__text">{{ text }}</div>
    </div>
    <bg-icon
      v-if="isOpen && handleToggle"
      class="BgBanner__close"
      name="close"
      @click.native="handleToggle"
    />
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import BgIcon from "@/components/bg-icon";
export default {
  name: "BgBanner",
  components: {
    BgIcon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: String,
    text: String,
    handleToggle: Function,
  },
  computed: {
    isBoxOpen() {
      return isOpen ? true : false;
    },
  },
};
</script>
